import { Controller } from 'react-hook-form';
import { IconLoader, InputSize, InputText } from '@ui/src';
import InfoRow from '../../common/info-row';
import StepPartBlock from '../../common/step-part-block';
import LicenseAndRegistration from './license-and-registration';
import { NewApplicationStatus } from '../../../../hoc/common/types';
import { AdditionalInformationBlockTypes } from './types';
import KeyContacts from './key-contacts';
import Checklist from './checklist';

import commonStyles from '../../common/styles.module.css';

const AdditionalInformation = ({
  applicationScheme,
  questionnarieControl,
  questionnarieClearErrors,
  questionnarieErrors,
  isEditable,
  status,
  questionnarieFields,
  questionnarieIsLoading,
}: AdditionalInformationBlockTypes) => (
  <>
    {questionnarieIsLoading && (
      <StepPartBlock withoutTitle>
        <div className={commonStyles.dictionaryLoader}>
          <IconLoader />
        </div>
      </StepPartBlock>
    )}
    {!questionnarieIsLoading && (
      <>
        {(applicationScheme?.typeOfBusinessLicenceActive ||
          applicationScheme?.hmrcMlrNumberActive ||
          applicationScheme?.hmrcRegistrationExpiryDateActive ||
          applicationScheme?.fcaNumberActive ||
          applicationScheme?.icoNumberActive) && (
          <LicenseAndRegistration
            applicationScheme={applicationScheme}
            questionnarieControl={questionnarieControl}
            questionnarieClearErrors={questionnarieClearErrors}
            questionnarieErrors={questionnarieErrors}
            isEditable={isEditable}
            status={status}
          />
        )}
        {(applicationScheme?.numberOfBranchesActive ||
          applicationScheme?.numberOfAgentsActive) && (
          <StepPartBlock title="Business Structure">
            <>
              {applicationScheme?.numberOfBranchesActive && (
                <InfoRow
                  title="Number of branches"
                  id="numberOfBranches"
                  lessPadding
                >
                  <Controller
                    control={questionnarieControl}
                    name="numberOfBranches"
                    defaultValue=""
                    render={({ field: { onChange, value } }) => (
                      <InputText
                        name="numberOfBranches"
                        placeholder="Enter number of branches..."
                        value={value}
                        onChange={(e) => {
                          onChange(e);
                          questionnarieClearErrors(['numberOfBranches']);
                        }}
                        size={InputSize.SMALL}
                        className="borderless"
                        error={questionnarieErrors?.numberOfBranches?.message}
                        tabIndex={
                          !isEditable &&
                          Boolean(
                            status === NewApplicationStatus.ACCEPTED ||
                            status === NewApplicationStatus.DECLINED,
                          )
                            ? -1
                            : 0
                        }
                        disabled={
                          !isEditable ||
                          Boolean(
                            status === NewApplicationStatus.ACCEPTED ||
                            status === NewApplicationStatus.DECLINED,
                          )
                        }
                      />
                    )}
                  />
                </InfoRow>
              )}
              {applicationScheme?.numberOfAgentsActive && (
                <InfoRow
                  title="Number of agents"
                  id="numberOfAgents"
                  lessPadding
                >
                  <Controller
                    control={questionnarieControl}
                    name="numberOfAgents"
                    defaultValue=""
                    render={({ field: { onChange, value } }) => (
                      <InputText
                        name="numberOfAgents"
                        placeholder="Enter number of agents..."
                        value={value}
                        onChange={(e) => {
                          onChange(e);
                          questionnarieClearErrors(['numberOfAgents']);
                        }}
                        size={InputSize.SMALL}
                        className="borderless"
                        error={questionnarieErrors?.numberOfAgents?.message}
                        tabIndex={
                          !isEditable &&
                          Boolean(
                            status === NewApplicationStatus.ACCEPTED ||
                            status === NewApplicationStatus.DECLINED,
                          )
                            ? -1
                            : 0
                        }
                        disabled={
                          !isEditable ||
                          Boolean(
                            status === NewApplicationStatus.ACCEPTED ||
                            status === NewApplicationStatus.DECLINED,
                          )
                        }
                      />
                    )}
                  />
                </InfoRow>
              )}
            </>
          </StepPartBlock>
        )}
        {(applicationScheme?.mlroDetailsActive ||
          applicationScheme?.complianceConsultantDetailsActive ||
          applicationScheme?.accountantDetailsActive ||
          applicationScheme?.itProviderDetailsActive ||
          applicationScheme?.payoutPartnerDetailsActive) && (
          <KeyContacts
            applicationScheme={applicationScheme}
            questionnarieControl={questionnarieControl}
            questionnarieClearErrors={questionnarieClearErrors}
            questionnarieErrors={questionnarieErrors}
            isEditable={isEditable}
            status={status}
          />
        )}
        <Checklist
          applicationScheme={applicationScheme}
          questionnarieControl={questionnarieControl}
          questionnarieClearErrors={questionnarieClearErrors}
          questionnarieErrors={questionnarieErrors}
          isEditable={isEditable}
          status={status}
          questionnarieFields={questionnarieFields}
        />
      </>
    )}
  </>
);

export default AdditionalInformation;
